'use strict';

import requestTpl from './change-password-request.html';
import successTpl from './change-password-success.html';

class ChangePasswordController {
    /* @ngInject */
    constructor($mdToast, UsersService, LoginService,
                $templateCache, $state) {
        Object.assign(this, {$mdToast, UsersService, LoginService, $state});
        $templateCache.put('change-password-request.html', requestTpl);
        $templateCache.put('change-password-success.html', successTpl);
        this.template = 'change-password-request.html';
    }

    changePassword() {
        this.updatePasswordStatus();
        console.log(this.form.$valid);
        if (this.form.$valid) {
            this.showSpin = true;
            this.UsersService.changePassword({
                oldPassword: this.oldPassword,
                newPassword: this.newPassword
            }).then(() => {
                this.template = 'change-password-success.html';
                setTimeout(() => {
                    setTimeout(()=>{ this.$state.go('login'); }, 0);
                }, 3000);
            }, err => {
                this.showSpin = false;
                let msg = 'Ocurrio un error. Por favor contacte con IRT';
                if (err.data.error.code === 'INVALID_PASSWORD') {
                    msg = 'La contraseña actual es incorrecta';
                }
                this.$mdToast.show(
                    this.$mdToast.simple()
                        .content(msg)
                        .position('top left')
                        .hideDelay(3000)
                        .parent('change-password')
                        .toastClass('error')
                );
                console.error(err);
            });
        }
    }

    updatePasswordStatus() {
        let newPasswordDifferentValidity = !!(
            this.oldPassword !== this.newPassword
        );
        this.form.newPassword
            .$setValidity('different', newPasswordDifferentValidity);

        let mustMatchValidity = !!(this.newPassword
            && this.newPasswordConfirmation
            && this.newPassword === this.newPasswordConfirmation);
        this.form.newPasswordConfirmation
            .$setValidity('mustMatch', mustMatchValidity);
    }
}

export default ChangePasswordController;
